<template>
  <b-container class="container-rda sidebar">
    <b-row class="height">
      <sidebar-admin />
      <b-col class="content">
        <b-row>
          <b-col>
            <Breadcrumb :breadcrumb="breadcrumb" />
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col>
            <h2 class="purple bold">Bloqueio RDA</h2>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end">
            <b-button
              variant="danger"
              class="large ml-2"
              @click="deleteRdaStatusBlock"
              :disabled="!loadedFromApi"
            >
              Excluir intervalo
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h3 class="purple">Definir intervalo</h3>

            <b-row>
              <b-col md="3">
                <b-form-group class="calendar" label="Data de início">
                  <Datepicker
                    v-model="blockBeginDate"
                    placeholder="Selecione"
                    format="dd/MM/yyyy"
                    :language="languages[language]"
                    @input="onFieldChange"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <StandardInput
                  v-model="blockBeginTime"
                  type="time"
                  name="begin_time"
                  label="Hora de início"
                  @input="onFieldChange"
                />
              </b-col>

              <b-col md="3">
                <b-form-group class="calendar" label="Data de fim">
                  <Datepicker
                    v-model="blockEndDate"
                    placeholder="Selecione"
                    format="dd/MM/yyyy"
                    :language="languages[language]"
                    @input="onFieldChange"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <StandardInput
                  v-model="blockEndTime"
                  type="time"
                  name="end_time"
                  label="Hora de fim"
                  @input="onFieldChange"
                />
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col md="3">
                <b-button
                  type="submit"
                  class="large blue"
                  @click="submitRdaStatusBlock"
                  :disabled="!canSave"
                >
                  {{ !loadedFromApi ? "Salvar" : "Atualizar" }} intervalo
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import httpRda from "../../../http-rda";
import SidebarAdmin from "../../../components/SidebarAdmin.vue";
import Datepicker from "vuejs-datepicker";
import StandardInput from "@/components/inputs/StandardInput.vue";
import moment from "moment-timezone";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  components: {
    SidebarAdmin,
    Datepicker,
    StandardInput,
  },

  data() {
    return {
      name: "bloqueioRda",
      loading: false,
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      blockBeginDate: null,
      blockBeginTime: null,
      blockEndDate: null,
      blockEndTime: null,
      loadedFromApi: false,
      hasChanges: false,
      originalValues: {
        blockBeginDate: null,
        blockBeginTime: null,
        blockEndDate: null,
        blockEndTime: null,
      },
      language: "ptBR",
      languages: lang,
      breadcrumb: [
        {
          text: "Administração",
          href: "/administracao",
        },
        {
          text: "Bloqueio RDA",
          href: "/administracao/bloqueio-rda",
        },
      ],
    };
  },

  computed: {
    allFieldsFilled() {
      return !!(
        this.blockBeginDate &&
        this.blockBeginTime &&
        this.blockEndDate &&
        this.blockEndTime
      );
    },

    canSave() {
      if (!this.allFieldsFilled) {
        return false;
      }

      if (!this.loadedFromApi) {
        return true;
      }

      return this.hasChanges;
    },
  },

  methods: {
    onFieldChange() {
      if (this.loadedFromApi) {
        this.checkForChanges();
      }
    },

    checkForChanges() {
      const currentBeginDate = this.blockBeginDate
        ? moment(this.blockBeginDate).format("YYYY-MM-DD")
        : null;
      const originalBeginDate = this.originalValues.blockBeginDate
        ? moment(this.originalValues.blockBeginDate).format("YYYY-MM-DD")
        : null;

      const currentEndDate = this.blockEndDate
        ? moment(this.blockEndDate).format("YYYY-MM-DD")
        : null;
      const originalEndDate = this.originalValues.blockEndDate
        ? moment(this.originalValues.blockEndDate).format("YYYY-MM-DD")
        : null;

      this.hasChanges =
        currentBeginDate !== originalBeginDate ||
        this.blockBeginTime !== this.originalValues.blockBeginTime ||
        currentEndDate !== originalEndDate ||
        this.blockEndTime !== this.originalValues.blockEndTime;
    },

    storeOriginalValues() {
      this.originalValues = {
        blockBeginDate: this.blockBeginDate
          ? new Date(this.blockBeginDate)
          : null,
        blockBeginTime: this.blockBeginTime,
        blockEndDate: this.blockEndDate ? new Date(this.blockEndDate) : null,
        blockEndTime: this.blockEndTime,
      };
      this.hasChanges = false;
    },

    async submitRdaStatusBlock() {
      if (
        !this.blockBeginDate ||
        !this.blockBeginTime ||
        !this.blockEndDate ||
        !this.blockEndTime
      ) {
        return this.$swal.fire({
          icon: "warning",
          title: "Preencha todas as datas e horários.",
        });
      }

      const formattedBegin = moment
        .tz(
          `${moment(this.blockBeginDate).format("YYYY-MM-DD")} ${
            this.blockBeginTime
          }`,
          "YYYY-MM-DD HH:mm",
          "America/Sao_Paulo"
        )
        .utc();

      const formattedEnd = moment
        .tz(
          `${moment(this.blockEndDate).format("YYYY-MM-DD")} ${
            this.blockEndTime
          }`,
          "YYYY-MM-DD HH:mm",
          "America/Sao_Paulo"
        )
        .utc();

      if (formattedEnd.isSameOrBefore(formattedBegin)) {
        return this.$swal.fire({
          icon: "warning",
          title: "A data/hora final deve ser maior que a data/hora inicial.",
        });
      }

      const now = moment().utc();
      if (formattedEnd.isSameOrBefore(now, "minute")) {
        return this.$swal.fire({
          icon: "warning",
          title: "A data/hora final deve ser maior que o horário atual.",
        });
      }

      const payload = {
        rdaStatusBlockBegin: formattedBegin.toISOString(),
        rdaStatusBlockEnd: formattedEnd.toISOString(),
      };

      try {
        await httpRda.post("/config/rda-status-block", payload);
        this.loadedFromApi = true;
        this.storeOriginalValues();
        this.$swal.fire({
          icon: "success",
          title: "Intervalo salvo com sucesso!",
        });
      } catch (error) {
        const msg =
          error.response?.data?.message || "Erro ao salvar intervalo!";
        this.$swal.fire({
          icon: "error",
          title: "Erro",
          text: msg,
        });
      }
    },

    deleteRdaStatusBlock() {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Esta ação irá remover o intervalo de bloqueio do RDA.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda.delete("/config/rda-status-block");

              this.$swal.fire({
                icon: "success",
                title: "Intervalo excluído com sucesso!",
              });
              this.loadedFromApi = false;
              this.hasChanges = false;
              this.clearFields();
            } catch (error) {
              const msg =
                error.response?.data?.message || "Erro ao excluir intervalo!";
              this.$swal.fire({
                icon: "error",
                title: "Erro",
                text: msg,
              });
            }
          }
        });
    },

    async loadRdaStatusBlock() {
      try {
        const response = await httpRda.get("/config/rda-status-block");
        const { rdaStatusBlockBegin, rdaStatusBlockEnd } = response.data.result;

        if (rdaStatusBlockBegin && rdaStatusBlockEnd) {
          this.loadedFromApi = true;
          const begin = moment.utc(rdaStatusBlockBegin).tz("America/Sao_Paulo");
          const end = moment.utc(rdaStatusBlockEnd).tz("America/Sao_Paulo");

          this.blockBeginDate = begin.toDate();
          this.blockBeginTime = begin.format("HH:mm");

          this.blockEndDate = end.toDate();
          this.blockEndTime = end.format("HH:mm");

          this.storeOriginalValues();
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Erro ao carregar intervalo",
          text:
            error.response?.data?.message ||
            "Não foi possível carregar o intervalo de bloqueio do RDA.",
        });
      }
    },

    clearFields() {
      this.blockBeginDate = null;
      this.blockBeginTime = null;
      this.blockEndDate = null;
      this.blockEndTime = null;
      this.originalValues = {
        blockBeginDate: null,
        blockBeginTime: null,
        blockEndDate: null,
        blockEndTime: null,
      };
    },
  },

  mounted() {
    this.loadRdaStatusBlock();
  },
};
</script>

<style scoped></style>
